/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';

import template from './review-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {deviceTargetSubDevices, hasAmount, previewParams} from './review-list-page-utils';
import {createReviewApproveHandler} from './review-commons';
import {ReviewRejectModalService} from './review-reject-modal.service';
import {LineItemResource} from '../../components/api/resources/resource/line-item.resource';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {StateService} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-review-list-page',
  template
})
export class ReviewListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adv.campaigns.campaign';
  readonly campaignItemStateName = 'app.adv.campaigns.campaign';
  readonly productItemStateName = 'app.adm.products.product';
  readonly orderItemStateName = 'app.adv.orders.order';
  readonly layoutItemStateName = 'app.adm.layouts.layout';
  readonly tierItemStateName = 'app.adm.tiers.tier';
  readonly userItemStateName = 'app.adm.users.user';

  readonly columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'selfServiceBudget'},
    {param: 'updateTime', label: 'dates'},
    {param: '', label: 'creativeInfo', sortable: false},
    {param: '', label: 'preview', sortable: false}
  ];

  readonly deviceTargetSubDevices = deviceTargetSubDevices;
  readonly hasAmount = hasAmount;
  readonly previewParams = previewParams;

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(LineItemResource) private readonly LineItem: any,
    private readonly $state: StateService,
    private readonly reviewRejectModalService: ReviewRejectModalService
  ) {
    super(LocalNetworkProfile);
  }

  previewHref(creative: any): string {
    return this.$state.href('nude.preview', previewParams(creative), {absolute: true}) || '';
  }

  protected afterListInit(): void {
    if (!this.list) {
      return;
    }
    if (!this.list.reject) {
      this.list.reject = this.reviewRejectModalService.createRejectHandler(this.list);
    }
    if (!this.list.approve) {
      this.list.approve = createReviewApproveHandler(this.list, this.LineItem);
    }
  }
}
